import React from 'react';
import ProfileCard from '../../../components/ProfileCard';
import { deriveCover480UrlFromDesktopCover } from '../../../utils/coverUtils';

const SimilarProfilesSection = ({ profiles }) => (
    <>
        <h2 className="text-lg font-semibold text-secondary-900 mb-4">Похожие профили</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {profiles.map((p) => (
                <ProfileCard
                    key={p.id}
                    profile={{
                        ...p,
                        cover_url_480: p?.cover_url_480 || deriveCover480UrlFromDesktopCover(p?.cover_url)
                    }}
                    preferCover480
                />
            ))}
        </div>
    </>
);

export default SimilarProfilesSection;
